import { render, staticRenderFns } from "./SimVanCollapseContent.vue?vue&type=template&id=481933b0&scoped=true"
import script from "./SimVanCollapseContent.vue?vue&type=script&lang=js"
export * from "./SimVanCollapseContent.vue?vue&type=script&lang=js"
import style0 from "./SimVanCollapseContent.vue?vue&type=style&index=0&id=481933b0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481933b0",
  null
  
)

export default component.exports